import styled from '@emotion/styled'
import { tokens } from '@news-mono/design-tokens'
import { calcRem, fonts } from '../../../__styling'

const chevron = require('./assets/ChevronDown.svg')

export const StyledSelect = styled.select(({ theme }) => ({
    padding: calcRem(12, 12),
    border: `1px solid ${
        theme.kind === 'sevennews'
            ? tokens.sevennews.colors.palette.gradialGrey
            : tokens.thenightly.colors.palette.neutral[20]
    }`,
    borderRadius: theme.kind === 'sevennews' ? calcRem(8) : calcRem(4),
    backgroundColor:
        theme.kind === 'sevennews'
            ? tokens.sevennews.colors.background.primary
            : tokens.thenightly.colors.palette.neutral[10],
    width: '100%',
    fontFamily:
        theme.kind === 'sevennews'
            ? fonts.sevennews.publication.headline
            : fonts.thenightly.publication.headline,
    fontWeight: 400,
    fontSize: calcRem(16),

    appearance: 'none',
    backgroundImage: `url(${chevron})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: calcRem(16),
    backgroundPosition: 'right 1rem center',

    ...(theme.kind === 'sevennews' && {
        outline: 'none',
        color: tokens.sevennews.colors.text.primary,
        '&:focus-visible': {
            outline: 'none',
            color: tokens.sevennews.colors.text.primary,
            borderColor: tokens.sevennews.colors.palette.red,
        },
    }),
}))

export const StyledLabel = styled.label(({ theme }) => ({
    color:
        theme.kind === 'sevennews'
            ? tokens.sevennews.colors.text.primary
            : tokens.thenightly.colors.palette.neutral[100],
    fontSize: calcRem(20),
    lineHeight: calcRem(28),
    fontWeight: 'bold',
}))

export const StyledSelectContainer = styled.div(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: calcRem(8),
}))
